import { ChartBuilder } from 'Molecules/InsightsChart/chartBuilder';
import { ChartType } from '../chartTypes';
import { BaseInsightPayload } from '../InsightDataPayload';
import { parseTasksDemandHoursPayload } from '../payloads/tasksDemandHoursPayload';
import { InsightChartFactory } from '../insightChartFactory';
import DefaultChartWithTrendSupport from 'Molecules/InsightsChart/DefaultChartWithTrendSupport';

export const buildTasksDemandHoursInsightFactory = (
  payload: BaseInsightPayload
): InsightChartFactory => {
  const parsedPayload = parseTasksDemandHoursPayload(payload);
  const { total_demand_hours } = parsedPayload.data.attributes.aggregate;

  return (props) => {
    const chart = new ChartBuilder()
      .setChartType(ChartType.KPI)
      .setProps({
        chartData: {
          value: total_demand_hours.current ?? 0,
          trend: total_demand_hours.percentage_change ?? 0,
          trendIsPercent: true,
          description: props.name,
        },
        onDrillDown: props.onDrillDown,
      })
      .build();

    return DefaultChartWithTrendSupport({
      chartComponent: chart,
    });
  };
};
